import { PropsWithChildren } from "react";
import classNames from "classnames";

export const FinalStepWrapper = ({ children }: PropsWithChildren) => {
  return (
    <div
      className={classNames("h-full", "w-full", "flex", "flex-col", "items-center", "justify-center")}
      data-testid="final-step-letter-wrapper"
    >
      {children}
    </div>
  );
};
